/**
 * This file is largely copied from extractAttachmentSuggestions.ts in owa-attachment-suggestions.
 * We are copying these files because this feature is still in a volatile state, so we wish to avoid
 * attempting to refactor the code so that it can be used here.
 * There is also ongoing experimentation with the Attachment Suggestions feature.
 */
import { ReplyWithAttachmentSuggestion } from 'owa-attachment-suggestions';
import { trace } from 'owa-trace';

const DEFAULT_MAXNUMBEROFATTACHMENTS: number = 3;

export default function extractAttachmentSuggestions(
    mruSuggestions: ReplyWithAttachmentSuggestion[],
    maxNumberOfAttachments: number = DEFAULT_MAXNUMBEROFATTACHMENTS
): ReplyWithAttachmentSuggestion[] {
    const extractedSuggestions: ReplyWithAttachmentSuggestion[] = [];
    let attachmentSuggestion: ReplyWithAttachmentSuggestion = null;

    if (mruSuggestions) {
        // Backfill with MRU suggestions
        for (
            let mruAttachmentIndex: number = 0;
            mruAttachmentIndex < mruSuggestions.length &&
            extractedSuggestions.length < maxNumberOfAttachments;
            mruAttachmentIndex++
        ) {
            attachmentSuggestion = mruSuggestions[mruAttachmentIndex];
            if (attachmentSuggestion) {
                extractedSuggestions.push(attachmentSuggestion);
            } else {
                trace.info('[extractAttachmentSuggestions] mru suggestion is null');
            }
        }
    }

    return extractedSuggestions;
}
